import { render, staticRenderFns } from "./PromoVideo.vue?vue&type=template&id=7447aac4&scoped=true&"
import script from "./PromoVideo.vue?vue&type=script&lang=js&"
export * from "./PromoVideo.vue?vue&type=script&lang=js&"
import style0 from "./PromoVideo.vue?vue&type=style&index=0&id=7447aac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447aac4",
  null
  
)

export default component.exports